import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';

import { CreateP2PScheduledMessageCommand } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { FileService } from 'src/app/core/services/file.service';
import { PrivateNumbersService } from '../../../core/api/services/private-numbers.service';
import { ScheduledMessagesService } from '../../../core/api/services/scheduled-messages.service';
import { DialogService } from '../../../core/services/dialog.service';
import { DynamicTabService } from '../../../core/services/dynamic-tab.service';
import { UtilityService } from '../../../core/services/utility.service';
import { SendP2pSmsComponent } from '../send-p2p-sms/send-p2p-sms.component';
import { TabsDynamicComponent } from './../../../layout/components/tabs-dynamic/tabs-dynamic.component';

@Component({
    selector: 'app-send-p2p-tracking-number-sms',
    templateUrl: './send-p2p-tracking-number-sms.component.html',
    styleUrls: ['../base/base-sending-system.component.scss'],
    standalone: false
})
export class SendP2pTrackingNumberSmsComponent
  extends SendP2pSmsComponent
  implements OnInit, OnDestroy
{
  //#region properties

  tabName: string = 'sendP2pTrackingNumberSms';

  //#endregion

  constructor(
    protected currentService: ScheduledMessagesService,
    protected dialogService: DialogService,
    protected utilityService: UtilityService,
    protected translate: TranslateService,
    protected dynamicTabService: DynamicTabService,
    protected privateNumberService: PrivateNumbersService,
    protected fileService: FileService,
    protected http: HttpClient,
    protected tabsDynamicComponent: TabsDynamicComponent
  ) {
    super(
      currentService,
      dialogService,
      utilityService,
      translate,
      dynamicTabService,
      privateNumberService,
      fileService,
      http,
      tabsDynamicComponent
    );
  }

  ngOnInit() {
    try {
      this.baseCreateGetApiForSend(
        this.currentService,
        'scheduledMessagesCreateTrackingNumberP2PScheduledMessageGet'
      );
      super.ngOnInit();
      this.pageVocabs = 'pages.sendP2pSms.';
      this.title = 'pages.sendP2pSms.trackingNumberTitle';
      this.configDirectDateTimeComponent();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  //#region api
  //create
  baseCreateApi(model: CreateP2PScheduledMessageCommand) {
    this.unSubs();
    this.sendLoading = true;
    this.loading = true;

    //this.model.pattern = this.model.pattern.toUpperCase();
    this.model.pattern = this.model.pattern.replace(/\[(.*?)\]/g, (item) =>
      item.toUpperCase()
    );

    this.currentService
      .scheduledMessagesCreateTrackingNumberP2PScheduledMessagePost({
        body: model,
      })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.sendLoading = false))
      )
      .subscribe((result) => {
        try {
          this.apiNotificationService.notifyMessage({
            result,
            mode: 'matDialog',
          });
          if (result.isSucceed) {
            this.onSuccess();
            this.refreshPage();
          }
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.sendingSystem
          );
        }
      });
  }
  //#endregion

  closeThisTab() {
    try {
      const TimeOut = setTimeout(() => {
        this.tabsDynamicComponent.manualCloseTab('sendP2pTrackingNumberSms');
        clearTimeout(TimeOut);
      }, 50);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }
}
